import {ServerError} from '@logistics-frontend/core/utils/network'

import {firstOf} from './firstOf'
import {get} from './get'

export const getErrorMessage = firstOf<ServerError, string>(
  get('body.message'),
  get('body.code'),
  get('message'),
  () => '🤷‍ Зовите фиксиков!',
) as (e: ServerError | Error) => string
